<template>
	<div class="row mb-4">
		<div class="col-2"></div>
		<div class="col-8">
			<div role="group">
				<label for="usernameref" class="fw-500">{{$t('login_username')}}</label>
				<b-form-input
					type="text"
					id="usernameref"
					v-model="username"
					:placeholder="$t('login_username_ph')"
					class="fw-500"
					trim
					:disabled="disabled"
				></b-form-input>
			</div>
			<div class="icon-profile-login">&nbsp;</div>
		</div>
		<div class="col-2"></div>
	</div>
</template>

<script>
export default {
	name: 'InputUsername',

	data (){
		return {
			username: null,
			disabled: false
		}
	},

	watch: {
		username(){
			this.$emit('update:updateUsername', {
				username: this.username
			});
		},
	},

	created(){
		//Seta o username caso venha de outra tela a informação
		this.username = this.$route.params.username;

		if (typeof this.username != "undefined" && this.username != null) {
			this.disabled = true;
		}
	},
}
</script>